<div class="container-fluid">
  <!-- Page Header with Action Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Staff Performance Report</h1>

    <!-- Action Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button
          [disabled]="this.isDisabled"
          [matTooltip]="disabledButtonTooltip"
          [matTooltipDisabled]="!this.isDisabled"
          style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="openDialog(SendUpdateAPIComponent, null, {
            endpoint: 'staff_performance_send_api',
            operation: 'Send API',
            form: { week: week, year: year }
          });">Send Report</button>

        <button
          [disabled]="this.isDisabled"
          [matTooltip]="disabledButtonTooltip"
          [matTooltipDisabled]="!this.isDisabled"
          style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="openDialog(SendUpdateAPIComponent, null, {
            endpoint: 'staff_performance_send_api',
            operation: 'Update API',
            form: { week: week, year: year }
          });">Update Report</button>

        <button style="background-color: transparent !important; border: none;"
          (click)="onPrint()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print staff performance report"
          matTooltipPosition="below"
          aria-label="Print staff performance report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>

        <button
          style="color:#fff; background-color: #6c757d !important; border-color: #6c757d !important;"
          mat-flat-button
          class="me-1 mb-1"
          [routerLink]="['/ami-reports']">
          Back to list
        </button>
      </div>
    </div>
  </div>

  <app-report-nav-menu [week]="this.week" [year]="this.year" [currentReport]="this.currentReport"></app-report-nav-menu>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">

        <!-- Instructor Autocomplete -->
        <!-- <div class="col-3">
          <mat-form-field class="full-width-field">
              <mat-label>Instructor</mat-label>
              <input
                  name="staff_name"
                  (input)="onAutocompleteInstructor($event)"
                  matInput
                  ngModel
                  [matAutocomplete]="autoCompleteInstructor"
                  > -->
              <!-- <button type="button" matSuffix mat-icon-button
                  aria-label="manage_accounts">
                  <mat-icon>manage_accounts</mat-icon>
              </button> -->
          <!-- </mat-form-field>
          <mat-autocomplete #autoCompleteInstructor="matAutocomplete"
              (optionSelected)="onSubmit(f)">
              <mat-option
                  *ngFor="let option of autocompleteInstructorOptions"
                  [value]="option.label + ' ' + '(' + option.value + ')'">
                  {{option.label}} ({{option.value}})
              </mat-option>
          </mat-autocomplete>
      </div> -->

        <app-week-year-selector
          [initialWeek]="week"
          [initialYear]="year"
          [disableOnFutureWeek]="true"
          (selectionChange)="onWeekYearChange($event)"
          (isDisabledChange)="isDisabled = $event">
        </app-week-year-selector>

        <section class="section">

          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
              <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
            </button>
          </div>

        </section>
      </div>


      <section class="section">
      </section>

    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>


  <table class="mat-table cdk-table mat-sort mt-4" role="table"
    *ngIf="data != undefined && data['#staff_header_table'] != undefined">
    <thead role="rowgroup">
      <tr>
        <th class="mat-header-cell">Report Type</th>
        <th class="mat-header-cell">Studio</th>
        <th class="mat-header-cell">Prepared By</th>
        <th class="mat-header-cell">Year</th>
        <th class="mat-header-cell">Week Number</th>
        <th class="mat-header-cell">Date Range</th>
      </tr>
    </thead>
    <tr>
      <td class="mat-row">{{ data['#staff_header_table']['staff_data_header']['#rows'][0][0] }}</td>
      <td class="mat-row">{{ currentStudio }}</td>
      <td class="mat-row">{{ data['#staff_header_table']['staff_data_header']['#rows'][0][1] }}</td>
      <td class="mat-row">{{ data['#staff_header_table']['staff_data_header']['#rows'][0][2] }}</td>
      <td class="mat-row">{{ data['#staff_header_table']['staff_data_header']['#rows'][0][3] }}</td>
      <td class="mat-row">{{ reportDateService.formatDate(data['#staff_header_table']['staff_data_header']['#rows'][0][5]) }} - {{ reportDateService.formatDate(data['#staff_header_table']['staff_data_header']['#rows'][0][6]) }}</td>
    </tr>
  </table>

  <div class="table-container">
    <mat-card>
        <mat-card-title>
          Instructors
        </mat-card-title>

        <mat-card-content>
          <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortDataView($event)" class="mt-4">
            <!-- name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Name">
                Name
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.name != undefined">{{ element.name }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">Total</td>
            </ng-container>

            <!-- staff_type Column -->
            <ng-container matColumnDef="staff_type">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by staff_type">
                Staff Type
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.staff_type != undefined">{{ element.staff_type }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- de/bonus Column -->
            <ng-container matColumnDef="de/bonus">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by de/bonus">
                <span class="text-nowrap" matTooltip="Complimentary lessons taught this week, Dance Evaluations, Bonus/Comp lessons, group and practice party sessions. These are not counted as Personal Lessons.">DE/Bonus <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element['de/bonus'] != undefined">{{ element['de/bonus'] }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">{{ getInstructorTotal('de/bonus') }}</td>
            </ng-container>

            <!-- number_of_guest Column -->
            <ng-container matColumnDef="number_of_guest">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by number_of_guest">
                <span class="text-nowrap" matTooltip="Guests credited to this staff member this week, students who came in through the Guest inquiry method.">Number of Guests <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.number_of_guest != undefined">{{ element.number_of_guest }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">{{ getInstructorTotal('number_of_guest') }}</td>
            </ng-container>

            <!-- private_lessons Column -->
            <ng-container matColumnDef="private_lessons">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by private_lessons">
                <span class="text-nowrap" matTooltip="Units of private lessons taught this week with a charged status (Showed / No Showed, Charged). Excludes DE/Bonus and Non Unit/Coaching lessons, which are counted in their own columns.">Personal Lessons <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.private_lessons != undefined">{{ element.private_lessons }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">{{ getInstructorTotal('private_lessons') }}</td>
            </ng-container>

            <!-- non_unit_coaching Column -->
            <ng-container matColumnDef="non_unit_coaching">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by non_unit_coaching">
                <span class="text-nowrap" matTooltip="Units of Non Unit Private lessons taught this week, including coaching lessons. These are broken out of Personal Lessons so the two columns don't overlap.">Non Unit/Coaching <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.non_unit_coaching != undefined">{{ element.non_unit_coaching }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">{{ getInstructorTotal('non_unit_coaching') }}</td>
            </ng-container>

            <!-- number_in_class Column -->
            <ng-container matColumnDef="number_in_class">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by number_in_class">
                <span class="text-nowrap" matTooltip="Students taught in group classes this week with a charged status (Showed / No Showed, Charged).">Number in Class <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.number_in_class != undefined">{{ element.number_in_class }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold">{{ getInstructorTotal('number_in_class') }}</td>
            </ng-container>

            <!-- interview_department Column -->
            <ng-container matColumnDef="interview_department">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by interview_department" class="text-end">
                <span class="text-nowrap" matTooltip="Dollar value of Interview (Front) Department enrollment sales credited to this staff member this week, minus drops.">Interview Dept <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <ng-container *ngIf="element.interview_department != undefined">{{ element.interview_department | studioCurrency }}
                </ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold text-end">{{ getInstructorTotal('interview_department') | studioCurrency }}</td>
            </ng-container>

            <!-- renewal_department Column -->
            <ng-container matColumnDef="renewal_department">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by renewal_department" class="text-end">
                <span class="text-nowrap" matTooltip="Dollar value of Renewal (Back) Department enrollment sales credited to this staff member this week, minus drops.">Renewal Dept <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <ng-container *ngIf="element.renewal_department != undefined">{{ element.renewal_department | studioCurrency }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold text-end">{{ getInstructorTotal('renewal_department') | studioCurrency }}</td>
            </ng-container>

            <!-- dor_sanct_competition Column -->
            <ng-container matColumnDef="dor_sanct_competition">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by dor_sanct_competition" class="text-end">
                <span class="text-nowrap" matTooltip="Dollar value of DOR and sanctioned competition package enrollments credited to this staff member this week, minus drops.">Dor/Sanct. Competition <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <ng-container *ngIf="element.dor_sanct_competition != undefined">{{ element.dor_sanct_competition | studioCurrency }}
                </ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold text-end">{{ getInstructorTotal('dor_sanct_competition') | studioCurrency }}</td>
            </ng-container>

            <!-- showcase_medal_ball Column -->
            <ng-container matColumnDef="showcase_medal_ball">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by showcase_medal_ball" class="text-end">
                <span class="text-nowrap" matTooltip="Dollar value of Showcase and Medal Ball package enrollments credited to this staff member this week, minus drops.">Showcase Medal Ball <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <ng-container *ngIf="element.showcase_medal_ball != undefined">{{ element.showcase_medal_ball | studioCurrency }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold text-end">{{ getInstructorTotal('showcase_medal_ball') | studioCurrency }}</td>
            </ng-container>

            <!-- party_time_non_unit Column -->
            <ng-container matColumnDef="party_time_non_unit">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by party_time_non_unit" class="text-end">
                <span class="text-nowrap" matTooltip="Dollar value of Party Time and non-unit package sales credited to this staff member this week, minus drops.">Party Time Non-Unit <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
              </th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <ng-container *ngIf="element.party_time_non_unit != undefined">{{ element.party_time_non_unit | studioCurrency }}</ng-container>
              </td>
              <td mat-footer-cell *matFooterCellDef class="fw-bold text-end">{{ getInstructorTotal('party_time_non_unit') | studioCurrency }}</td>
            </ng-container>

            <!-- REPLACE Column -->
            <!-- <ng-container matColumnDef="REPLACE">
              <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by REPLACE">
                REPLACE
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.REPLACE">{{ element.REPLACE }}</ng-container>
              </td>
            </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          </table>
  </mat-card-content>
  </mat-card>
  </div>

  <div class="table-container">
    <mat-card *ngIf="this.staffPerformanceExecutives?.[0]">
        <mat-card-title>
          Executives
        </mat-card-title>

        <mat-card-content>

        <table class="mat-table cdk-table mat-sort mt-4" role="table"
            *ngIf="data != undefined && this.staffPerformanceExecutives?.[0] != undefined">
            <thead role="rowgroup">
                <tr>
                    <th class="mat-header-cell">Name</th>
                    <th class="mat-header-cell">Staff Type</th>
                    <th class="mat-header-cell">&nbsp; <!--DE/Bonus--></th>
                    <th class="mat-header-cell">&nbsp; <!--Number of Guests--></th>
                    <th class="mat-header-cell">&nbsp; <!--Private Lessons--></th>
                    <th class="mat-header-cell">&nbsp; <!--Non Unit/Coaching--></th>
                    <th class="mat-header-cell">&nbsp; <!--Number in Class--></th>
                    <th class="mat-header-cell">
                        <span class="text-nowrap" matTooltip="Dollar value of DOR and sanctioned competition package enrollments credited to this staff member this week, minus drops.">Dor/Sanct. Competition <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                    </th>
                    <th class="mat-header-cell">
                        <span class="text-nowrap" matTooltip="Dollar value of Showcase and Medal Ball package enrollments credited to this staff member this week, minus drops.">Showcase Medal Ball <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                    </th>
                    <th class="mat-header-cell">
                        <span class="text-nowrap" matTooltip="Dollar value of Party Time and non-unit package sales credited to this staff member this week, minus drops.">Party Time Non-Unit <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                    </th>
                    <th class="mat-header-cell">
                        <span class="text-nowrap" matTooltip="Dollar value of Interview (Front) Department enrollment sales credited to this staff member this week, minus drops.">Interview Dept <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                    </th>
                    <th class="mat-header-cell">
                        <span class="text-nowrap" matTooltip="Dollar value of Renewal (Back) Department enrollment sales credited to this staff member this week, minus drops.">Renewal Dept <mat-icon class="help-icon-inline">help_outline</mat-icon></span>
                    </th>
                </tr>
            </thead>
            <tr *ngFor="let refund of this.staffPerformanceExecutives ; index as i;">
                <td class="mat-row">{{ this.staffPerformanceExecutives[i]['name'] }}</td>
                <td class="mat-row">{{ this.staffPerformanceExecutives[i]['staff_type'] }}</td>
                <td class="mat-row">&nbsp; <!--{{ this.staffPerformanceExecutives[i]['de/bonus'] }}>--></td>
                <td class="mat-row">&nbsp; <!--${{ this.staffPerformanceExecutives[i]['number_of_guest'] }}--></td>
                <td class="mat-row">&nbsp; <!--${{ this.staffPerformanceExecutives[i]['private_lessons'] }}--></td>
                <td class="mat-row">&nbsp; <!--${{ this.staffPerformanceExecutives[i]['non_unit_coaching'] }}--></td>
                <td class="mat-row">&nbsp; <!--${{ this.staffPerformanceExecutives[i]['number_in_class'] }}--></td>
                <td class="mat-row text-end">{{ this.staffPerformanceExecutives[i]['dor_sanct_competition'] | studioCurrency }}</td>
                <td class="mat-row text-end">{{ this.staffPerformanceExecutives[i]['showcase_medal_ball'] | studioCurrency }}</td>
                <td class="mat-row text-end">{{ this.staffPerformanceExecutives[i]['party_time_non_unit'] | studioCurrency }}</td>
                <td class="mat-row text-end">{{ this.staffPerformanceExecutives[i]['interview_department'] | studioCurrency }}</td>
                <td class="mat-row text-end">{{ this.staffPerformanceExecutives[i]['renewal_department'] | studioCurrency }}</td>
            </tr>
            <tr>
                <td class="mat-row fw-bold">Total</td>
                <td class="mat-row"></td>
                <td class="mat-row">&nbsp;</td>
                <td class="mat-row">&nbsp;</td>
                <td class="mat-row">&nbsp;</td>
                <td class="mat-row">&nbsp;</td>
                <td class="mat-row">&nbsp;</td>
                <td class="mat-row text-end fw-bold">{{ getExecutiveTotal('dor_sanct_competition') | studioCurrency }}</td>
                <td class="mat-row text-end fw-bold">{{ getExecutiveTotal('showcase_medal_ball') | studioCurrency }}</td>
                <td class="mat-row text-end fw-bold">{{ getExecutiveTotal('party_time_non_unit') | studioCurrency }}</td>
                <td class="mat-row text-end fw-bold">{{ getExecutiveTotal('interview_department') | studioCurrency }}</td>
                <td class="mat-row text-end fw-bold">{{ getExecutiveTotal('renewal_department') | studioCurrency }}</td>
            </tr>
        </table>

        </mat-card-content>
    </mat-card>

    <ng-container *ngIf="!ShowProgressBar && this.pageSize == 0">
      <div>
        Please select criteria to generate a report.
      </div>
    </ng-container>

    <mat-paginator style="display: none;" (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="10"
      [disabled]="ShowProgressBar"
      [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator>

</div>
